import { message } from 'antd';
import FileRepository from 'services/api-repositories/files/FileRepository';
import { openErrorNotification } from 'hyarchis-global/components/notifications';
import { AxiosError } from 'axios';

export default (fileId: string, fullName = 'file.txt') =>
  async () => {
    message.success(`Downloading ${fullName} as text...`, 1);
    let fileContent;
    try {
      fileContent = await FileRepository.get(fileId);
    } catch (error) {
      openErrorNotification((error as AxiosError).message);
    }

    if (fileContent) {
      try {
        const text = await fileContent.text();

        const printableChars = text.replace(/[\x20-\x7E\s]/g, '').length;
        const totalChars = text.length;
        const printableRatio = printableChars / totalChars;

        if (printableRatio > 0.1) {
          message.warning(
            'This file may contain binary data. Text extraction may not be complete.',
            3,
          );
        }

        const blob = new Blob([text], { type: 'text/plain; charset=utf-8' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fullName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (textError) {
        message.warning('Could not convert to text properly. Downloading raw content.', 3);
        const url = window.URL.createObjectURL(fileContent);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fullName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    }
  };
